import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

// Services
import { BaseService } from '../../../shared/services/base.service';
import { ConfigService } from '../../../shared/utils/config.service';

// models
import { OrderHeader } from '../models/orderHeader.model';
import { OrderFilter } from '../models/order-filter.model';
import { DynamicPriceFilterModel } from '../models/dynamicPriceFilter.model';

@Injectable({
  providedIn: 'root'
})
export class ClorasApiService extends BaseService {
  baseApiUrl: string = '';
  apiurl: string = '';
  APIConfigurationUrl: string = '';
  postOrderAPIUrl: string = '';
  getOrderAPIUrl: string = '';
  getCategoryAPIUrl: string = '';
  getSubCategoryAPIUrl: string = '';
  getMaterialByCategorySubCategoryListApiUrl: string = '';
  getMonthlyEStatementsApiUrl: string = '';
  getSunriseOrderAPIUrl: string = '';
  getProductCategoryApiUrl: string = '';
  getProductSubCategory1ApiUrl: string = '';
  getProductSubCategory2ApiUrl: string = '';
  getProductSearchApiUrl: string = '';
  getSunriseProductSearchApiUrl: string = '';
  getOrdersByTypeApiUrl: string = '';
  getOrderDetailsByOrderIdApiUrl: string = '';
  putOrderNoApiUrl: string = '';
  getDyanamicPriceApiUrl: string = '';
  updateDeleteFlagApiUrl: string = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();

    this.baseApiUrl = this.configService.getApiURI();
    this.apiurl = this.baseApiUrl + '/Sunrise/';
    this.APIConfigurationUrl = this.baseApiUrl + '/APIConfig';
    this.postOrderAPIUrl = this.baseApiUrl + '/Order/PostOrder';
    this.getOrderAPIUrl = this.baseApiUrl + '/Order/GetOrder';
    this.getCategoryAPIUrl = this.baseApiUrl + '/Order/Category';
    this.getSubCategoryAPIUrl = this.baseApiUrl + '/Order/SubCategory';
    this.getMaterialByCategorySubCategoryListApiUrl = this.baseApiUrl + '/Order/GetMaterialByCategorySubCategory';
    this.getMonthlyEStatementsApiUrl = this.baseApiUrl + '/Accounting/MonthlyEStatements';
    this.getProductCategoryApiUrl = this.baseApiUrl + '/ProductSearch/GetProductCategory';
    this.getProductSubCategory1ApiUrl = this.baseApiUrl + '/ProductSearch/GetProductSubCategory1';
    this.getProductSubCategory2ApiUrl = this.baseApiUrl + '/ProductSearch/GetProductSubCategory2';
    this.getProductSearchApiUrl = this.baseApiUrl + '/ProductSearch/GetProductSearch';
    this.getSunriseProductSearchApiUrl = this.baseApiUrl + '/ProductSearch/GetSunriseProductSearch';
    this.getSunriseOrderAPIUrl = this.baseApiUrl + '/Order/GetSunriseOrder';
    this.getOrdersByTypeApiUrl = this.baseApiUrl + '/Order/GetOrdersByType';
    this.getOrderDetailsByOrderIdApiUrl = this.baseApiUrl + '/Order/GetOrderDetailsByOrderId';
    this.putOrderNoApiUrl = this.baseApiUrl + '/Order/PutOrderNo';
    this.getDyanamicPriceApiUrl = this.baseApiUrl + '/ProductSearch/GetDynamicPriceForFrontEnd';
    this.updateDeleteFlagApiUrl = this.baseApiUrl + '/Order/UpdateDeleteFlag';

  }

  // This method is used to call a controller which will call Cloras API
  SunriseApiCall(body: any, type: string) {
    try {
      return this.http.post(this.apiurl + type, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  GetAPIConfiguration() {
    try {
      return this.http.get(this.APIConfigurationUrl);
    }
    catch (Ex) {
    }
  }

  GetOrderItems() {
    try {
      return this.http.get("/assets/sunrise/orderItems.json");
    }
    catch (Ex) {
    }
  }

  GetShipToID() {
    try {
      return this.http.get("/assets/sunrise/shipToID.json");
    }
    catch (Ex) {
    }
  }

  postOrder(orderHeader: OrderHeader) {
    try {
      return this.http.post(this.postOrderAPIUrl, orderHeader);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  getOrder() {
    try {
      return this.http.get(this.getOrderAPIUrl);
    }
    catch (Ex) {
    }
  }

  getCategory(distributorId: number) {
    try {
      return this.http.get(this.getCategoryAPIUrl + "/" + distributorId);
    }
    catch (Ex) {
    }
  }

  getSubCategory(categoryId: number) {
    try {
      return this.http.get(this.getSubCategoryAPIUrl + "/" + categoryId);
    }
    catch (Ex) {
    }
  }

  // Product Search - Show Items/Materials
  getMaterialByCategorySubCategory(body: any) {
    try {
      return this.http.post(this.getMaterialByCategorySubCategoryListApiUrl, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  // Get
  getMonthlyEStatements(customerId: string, year: string) {
    try {
      return this.http.get(this.getMonthlyEStatementsApiUrl + "/" + customerId + "/" + year);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  getSunriseOrderDetails(orderFilter: OrderFilter) {
    try {
      return this.http.post(this.getSunriseOrderAPIUrl, orderFilter);
    }
    catch (Ex) {
    }
  }

  // Get Product Category
  getProductCategory() {
    try {
      return this.http.get(this.getProductCategoryApiUrl);
    }
    catch (Ex) {
    }
  }

  // Get Product Sub-Category 1
  getProductSubCategory1(categoryId: number) {
    try {
      return this.http.get(this.getProductSubCategory1ApiUrl + "/" + categoryId);
    }
    catch (Ex) {
    }
  }

  // Get Product Sub-Category 2
  getProductSubCategory2(categoryId: number) {
    try {
      return this.http.get(this.getProductSubCategory2ApiUrl + "/" + categoryId);
    }
    catch (Ex) {
    }
  }

  // Product Search - Show P21 Items/Materials
  getProductSearch(body: any, customerID: number, searchType: string) {
    try {
      if (searchType == "ByCategory") {
        return this.http.post(this.getProductSearchApiUrl + "/" + customerID, body);
      }
      else {
        return this.http.post(this.getSunriseProductSearchApiUrl + "/" + customerID, body);
      }
    }
    catch (Ex) {
      throw Ex;
    }
  }

  // Get Internal and Draft Orders
  getOrdersByType(type: string, customerID: number, loggedInUserId) {
    try {
      return this.http.get(this.getOrdersByTypeApiUrl + "/" + type + "/" + customerID + "/" + loggedInUserId);
    }
    catch (Ex) {
    }
  }

  // Get Order Details By OrderId
  getOrderDetailsByOrderId(orderId: number) {
    try {
      return this.http.get(this.getOrderDetailsByOrderIdApiUrl + "/" + orderId);
    }
    catch (Ex) {
    }
  }

  //update order no in qubesense DB
  putOrderNo(order_no: string, web_reference_no: string) {
    try {
      return this.http.get(this.putOrderNoApiUrl + "/" + order_no + "/" + web_reference_no);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  getDynamicPriceForFrontEnd(body: DynamicPriceFilterModel, customerId:number) {
    try {
      return this.http.post(this.getDyanamicPriceApiUrl + "/" + customerId, body);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  // Update delete_flag - orderId in Qubesense DB
  updateDeleteFlag(orderId: number, deleteFlag: string) {
    try {
      return this.http.get(this.updateDeleteFlagApiUrl + "/" + orderId + "/" + deleteFlag);
    }
    catch (Ex) {
      throw Ex;
    }
  }

}
